import { render, staticRenderFns } from "./comp_BookEditorCustomizationInputs-egresaditos.vue?vue&type=template&id=807ea268&scoped=true&"
import script from "./comp_BookEditorCustomizationInputs-egresaditos.vue?vue&type=script&lang=js&"
export * from "./comp_BookEditorCustomizationInputs-egresaditos.vue?vue&type=script&lang=js&"
import style0 from "./comp_BookEditorCustomizationInputs-egresaditos.vue?vue&type=style&index=0&id=807ea268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807ea268",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
